//      
import React, { Component } from 'react';
import styled from 'styled-components';

import { mergeClassNames } from 'utils/functions';

                            
                               
                                
                                  
                     
                                          
                      
  

const StyledDL = styled.dl`
    dt,
    dd {
        margin-bottom: 0.5rem;
    }
`;

/** A component for a definition list. */
export class DefinitionList extends Component                      {
    static defaultProps = {
        termSize: '',
        className: '',
    };

    render() {
        // pass in a list of two-lists: [['label', 'value'], ]
        const { items, className, termSize, ...domProps } = this.props;
        // const classNameMerge = mergeClassNames('row', this.props.className);

        const dtClass = `col-${termSize}`;
        const ddClass = `col-${12 - termSize}`;

        // check to see if termSize is specified...
        if (termSize) {
            // if so, return complex instance, including 'row' wrapper class...
            return (
                // complex
                <StyledDL {...domProps} className={mergeClassNames('row', className)}>
                    {items.filter(i => i).map(([name, value = ''], i) => {
                        return [
                            <dt className={dtClass} key={'dt-' + i.toString()}>
                                {name}
                            </dt>,
                            <dd className={ddClass} key={'dd-' + i.toString()}>
                                {value}
                            </dd>,
                        ];
                    })}
                </StyledDL>
            );
        } else {
            if (className) {
                domProps.className = className;
            }
            // if not, return simple instance, with class name only...
            return (
                // simple
                <StyledDL {...domProps}>
                    {items.map(([name, value = ''], i) => {
                        return [
                            <dt key={'dt-' + i.toString()}>{name}</dt>,
                            <dd key={'dd-' + i.toString()}>{value}</dd>,
                        ];
                    })}
                </StyledDL>
            );
        }
    }
}

export default DefinitionList;
